export const OPEN_MENU = "OPEN_MENU";
export const CLOSE_MENU = "CLOSE_MENU";
export const GO_HOME = "GO_HOME";
export const GONE_HOME = "GONE_HOME";
import RefreshTokenTimeout from "../../layouts/LoginRequired";

export function openMenu() {
  return {
    type: OPEN_MENU,
  };
}

export function closeMenu() {
  return {
    type: CLOSE_MENU,
  };
}

export function goHome() {
  return {
    type: GO_HOME,
  };
}

export function goHomeReceived() {
  return {
    type: GONE_HOME,
  };
}

export function resetStore() {
  console.log("RESETTING");
  return {
    type: "RESET_STORE",
  };
}

export function logout() {
  clearTimeout(RefreshTokenTimeout);
  return {
    type: "LOGOUT_STORE",
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/menu.js